import React, { useEffect, useState } from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';

export interface Props {
    expand?: boolean,
    titleText?: string | JSX.Element;
}

export function GenericAccordion(props: React.PropsWithChildren<Props>) {
    const [expand, setExpand] = useState(props?.expand);

    useEffect(() => {
        setExpand(props?.expand);
    }, [props?.expand]);

    const renderTitle = (titleText: string | JSX.Element | number) => {
        if (typeof titleText === 'string') {
            return (
                <p>{titleText}</p>
            );
        }

        return titleText;
    };

    return (
        <Accordion expanded={expand} onChange={() => setExpand(!expand)}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
            >
                {renderTitle(props.titleText)}
            </AccordionSummary>
            <AccordionDetails>
                <div>
                    {props.children}
                </div>
            </AccordionDetails>
        </Accordion>
    );
}


GenericAccordion.defaultProps = {
    expand: true,
    titleText: null,
};